import { createReducer, on } from '@ngrx/store';
import * as FuelGasActions from './monthly-report.actions';
import { SGPFGDCalculatedDTO } from 'src/app/web-api-client';

export interface MonthlyReportSGPState{
  data: SGPFGDCalculatedDTO[] | null; 
  result: any;
  isLoading: boolean;
  isLoadingSuccess: boolean;
  isLoadingFailure: boolean;
}

const initialState: MonthlyReportSGPState = {
  data: null,
  result: '',
  isLoading: false,
  isLoadingSuccess: false,
  isLoadingFailure: false,
};

export const MonthlyReportSGPReducer = createReducer(
  initialState,
  on(FuelGasActions.getMonthlyFuelGas, (state, result) => ({
    ...state,
    isLoading: true,
  })),
  on(FuelGasActions.getMonthlyFuelGasSuccess, (state, result) => ({
    data: result.data,
    result,
    isLoading: false,
    isLoadingSuccess: true,
    isLoadingFailure: false,
  })),
  on(FuelGasActions.getMonthlyFuelGasFailure, (state, result) => ({
    ...state,
    result,
    isLoading: false,
    isLoadingFailure: true,
  })),
  on(FuelGasActions.RefreshMonthlyManualRecords , (state, payload) => ({
    ...state,
    isLoading: true,
  })),
  on(FuelGasActions.RefreshMonthlyManualRecordsSuccess , (state, payload) => ({
    ...state,
    result: payload,
    isLoading: false,
    isLoadingSuccess: true,
  })),
  on(FuelGasActions.RefreshMonthlyManualRecordsFailure, (state, payload) => ({
    ...state,
    result: payload.message,
    isLoading: false,
    isLoadingFailure: true,
  }))
);